/**
* @version GENERATOR_VERSION::20200422
* @DateTime 2020-05-07T09:38:27.974
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getCCBContractFeesEditInit,
	getCCBContractFeesView
} from '@api/house/CCBContractFees';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},

	actions: {
		getCCBContractFeesEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractFeesEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getCCBContractFeesView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getCCBContractFeesView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
